"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../../createSvgIcon"));

var _AngleLeft = _interopRequireDefault(require("@rsuite/icon-font/lib/legacy/AngleLeft"));

// Generated by script, don't edit it please.
var AngleLeft = (0, _createSvgIcon["default"])({
  as: _AngleLeft["default"],
  ariaLabel: 'angle left',
  category: 'legacy',
  displayName: 'AngleLeft'
});
var _default = AngleLeft;
exports["default"] = _default;
module.exports = exports.default;